// extracted by mini-css-extract-plugin
export var actionButton = "_du-t";
export var buttonContainer = "_du-0";
export var buttonContainer2 = "_du-1";
export var buttonSection = "_du-2";
export var details = "_du-3";
export var dropdownItem = "_du-5";
export var dropdownItemsContainer = "_du-4";
export var fileInput = "_du-r";
export var headerButton = "_du-6";
export var icon = "_du-7";
export var input = "_du-8";
export var macroListItem = "_du-9";
export var mainContent = "_du-a";
export var microText = "_du-b";
export var modal = "_du-w";
export var optionsButton = "_du-c";
export var paperclip = "_du-s";
export var pillContent = "_du-d";
export var preview = "_du-e";
export var preview2 = "_du-f";
export var quillEditor = "_du-q";
export var selectedMacro = "_du-g";
export var sidebar = "_du-h";
export var sidebarHeader = "_du-j";
export var sidebarList = "_du-i";
export var sidebarListItem = "_du-k";
export var sidebarSearch = "_du-l";
export var snoozeDurationWrapper = "_du-v";
export var statusPillContainer = "_du-m";
export var tagsContainer = "_du-n";
export var unselectedMacro = "_du-o";
export var variable = "_du-u";
export var wrapper = "_du-p";